import {
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Subscription, Observable } from 'rxjs';

interface AutoCompleteOption {
  id: number;
  name: string;
}

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
  standalone: false,
})
export class SearchFieldComponent implements OnInit, OnDestroy, OnChanges {
  @Input() placeholderText: string;
  @Input() label: string;
  @Input() isLoading$: Observable<boolean>;
  @Input() autoCompleteOptions: Observable<Array<AutoCompleteOption>>;
  @Input() value: string;

  @Output() searchValueChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() optionSelected: EventEmitter<unknown> = new EventEmitter<unknown>();

  searchField = new FormControl();
  private subscription: Subscription;

  constructor() {}

  ngOnInit(): void {
    this.subscription = this.searchField.valueChanges.subscribe((searchtext: string) => {
      this.searchValueChanged.emit(searchtext);
    });
    this.searchField.setValue(this.value, { emitEvent: false });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      'value' in changes &&
      !changes['value'].firstChange &&
      this.searchField.value !== this.value
    ) {
      this.searchField.setValue(this.value, { emitEvent: false });
    }
  }

  ngOnDestroy = () => this.subscription.unsubscribe();

  selectOption(event: MatAutocompleteSelectedEvent) {
    this.optionSelected.emit(event.option.value);
  }

  getOptionSelectName = (option: AutoCompleteOption) => (option ? option.name : undefined);

  clearSearchbox = () => this.searchField.setValue('');
}
